import { pipe } from 'ramda';
import { createSelector } from 'reselect';

import { IRootState } from '../../../store/root.types';

import { ICodeState } from './code.reducer';

const pathToCodeState = (state: IRootState): ICodeState => state.code;

export const getIsLoading = pipe(pathToCodeState, state => state.isLoading);

export const getErrors = createSelector(pathToCodeState, state => state.errors);

export const hasErrors = createSelector(pathToCodeState, state => Object.keys(state.errors).length > 1);

export const getErrorCode = createSelector(pathToCodeState, state => state.errors.code ?? '');

export const getRedirectUrl = createSelector(pathToCodeState, state => state.redirectUrl);

export const getParams = createSelector(pathToCodeState, state => state.params);
